























import { Component, Vue, Prop } from 'vue-property-decorator';
import ProjectShow from '@/components/Project/ProjectShow.vue';
import { GQL_currentUnitProjects_currentUnit_projects } from '@/queries/__generated__/currentUnitProjects';

@Component({
  components: {
    ProjectShow,
  },
})
export default class ProjectShowButton extends Vue {
  @Prop() public project!: GQL_currentUnitProjects_currentUnit_projects;
  public showDialog = false;
}
